import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import type { Strategy } from "@repo/strategy/client";
import type { DirectIndexConstituentsResult } from "../data/direct-index-queries";
import type { BuilderRecipeState } from "./recipe-store";

export interface DirectIndexCheckoutRequest {
  readonly constituents: DirectIndexConstituentsResult | null;
  readonly strategy?: Strategy;
  readonly onPortfolioCreated: () => void;
  readonly recipe: BuilderRecipeState;
  readonly nameDraft?: string;
}

function useCreateCheckoutSession() {
  const [request, setRequest] = useState<DirectIndexCheckoutRequest | null>(
    null,
  );
  return useMemo(() => ({ request, setRequest }), [request]);
}
const CheckoutSessionContext = createContext<ReturnType<
  typeof useCreateCheckoutSession
> | null>(null);
function CheckoutSessionRoot(props: { readonly children: ReactNode }) {
  const session = useCreateCheckoutSession();
  return (
    <CheckoutSessionContext.Provider value={session}>
      {props.children}
    </CheckoutSessionContext.Provider>
  );
}
export function CheckoutSessionProvider(props: {
  readonly children: ReactNode;
  readonly inherit?: boolean;
}) {
  const inherited = useContext(CheckoutSessionContext);
  return props.inherit && inherited ? (
    props.children
  ) : (
    <CheckoutSessionRoot>{props.children}</CheckoutSessionRoot>
  );
}
export function useCheckoutSession() {
  const session = useContext(CheckoutSessionContext);
  if (!session) throw new Error("Builder checkout session provider is missing");
  return session;
}
